import { assign } from 'xstate';
import ObjectId from '../ObjectId';

export function addRuleChange(context, eventId = new ObjectId().toString()) {
    return { pendingRuleChanges: [...context.pendingRuleChanges, eventId] };
}

export function isCurrentRuleChange(context, event) {
    const eventId = event.payload?.originatingEventContext?.eventId;
    // Accept replies without an ID only when no identified request is pending.
    // They cannot complete an identified request.
    return eventId == null ? context.pendingRuleChanges.length === 0 : context.pendingRuleChanges.includes(eventId);
}

export const beginRuleChange = assign((context, event) =>
    addRuleChange(context, event.type === 'changePending' ? event.payload?.originatingEventContext?.eventId : undefined)
);

export const finishRuleChange = assign({
    pendingRuleChanges: (context, event) =>
        context.pendingRuleChanges.filter(eventId => eventId !== event.payload?.originatingEventContext?.eventId)
});

export const reportRuleChangeFailure = (context, event) => {
    if (event.payload?.errors) context.onRuleChangeFailure?.(event.payload.errors);
};

export const rememberSubmission = assign({
    submissionEvent: (context, event) => event
});
